import React, { useState } from "react";
import { useSendResetLinkMutation } from "../slices/authSlice";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sendResetLink, { isLoading, isSuccess }] = useSendResetLinkMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendResetLink({ email }).unwrap();
      alert("Password reset link sent to your email.");
    } catch (error) {
      alert("Failed to send reset link. Try again.");
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-xl font-semibold mb-4">Forgot Password</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            Email Address
          </label>
          <input
            type="email"
            id="email"
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white py-2 px-4 rounded-md"
          disabled={isLoading}
        >
          {isLoading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>
      {isSuccess && <p className="text-green-600">Reset link sent!</p>}
    </div>
  );
};

export default ForgotPassword;
